import { Location } from "@carbon/icons-react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import {
  InboundDeliveryFragment,
  InboundDeliveryOverviewFragment,
} from "../../models/autogenerated-deliveryService-gql/graphql";
import "./DeliveryGeneralInfo.scss";
import ActionsButtonWithPopover from "./actionsButtonWithPopover/ActionsButtonWithPopover";

interface DeliveryGeneralInfoProps {
  delivery: InboundDeliveryFragment | InboundDeliveryOverviewFragment;
  showLocation: boolean;
  showActions: boolean;
  secondaryColoring?: boolean;
}

const DeliveryGeneralInfo = (props: DeliveryGeneralInfoProps) => {
  const { t } = useTranslation();

  const { delivery, showActions, showLocation, secondaryColoring } = props;

  const dividerClassName = `${"page-content-divider"} ${
    secondaryColoring ? "bright-border" : ""
  }`;

  const renderCreated = `${t("createdAt")} ${moment(
    new Date(delivery.createdAt),
  ).format(t("dateTimeYearFormat"))} ${t("by")} ${t(delivery.createdBy ?? "")}`;

  const renderChanged = `${
    delivery.changedAt
      ? `${t("changed")} ${moment(new Date(delivery.changedAt)).format(
          t("dateTimeYearFormat"),
        )} ${t("by")} ${t(delivery.changedBy ?? "")}`
      : ""
  }`;

  const renderLocation = `${delivery.locationResolved ? delivery.locationResolved.name : ""}`;

  const renderHistoryRow = (
    <div className="page-content-row-start mt-20">
      <div className="page-content-row-item-bold page-content-row-item-fixed-width">
        {t("history")}
      </div>
      <div className="page-content-row page-content-row-fixed-width-70 ml-20">
        <div className="row-item-created">{renderCreated}</div>
        <div className="row-item-changed">{renderChanged}</div>
      </div>
      {showActions && (
        <div className="page-content-row-right ">
          <div className="page-content-row-space-between page-content-row ml-20">
            <div className="page-content-row-item">
              <ActionsButtonWithPopover
                actions={delivery.actions}
                deliveryId={delivery.id}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const renderDocumentRow = (
    <div className="mb-16 page-content-row-start">
      <div className="page-content-row-item-bold page-content-row-item-fixed-width">
        {t("document")}
      </div>
      <div className="page-content-row-space-between page-content-row-fixed-width-70 ml-20">
        <div className="page-content-row-item-max-space">
          {`${t(delivery.documentType || "")} | ${delivery.documentNumber}`}
        </div>
      </div>
    </div>
  );

  const renderLocationRow = (
    <div className="page-content-row-start mb-20">
      <div className="page-content-row-item-bold page-content-row-item-fixed-width">
        {t("location")}
      </div>
      <div className="page-content-row-space-between page-content-row-fixed-width-70 ml-20">
        <div>{renderLocation}</div>
        <div>
          <Location size={24} />
        </div>
      </div>
    </div>
  );

  return (
    <div className="w-100" data-testid="detailsGeneralInfo">
      <div className={dividerClassName} />
      {renderHistoryRow}
      {renderDocumentRow}
      {showLocation && renderLocationRow}
      <div className={dividerClassName} />
    </div>
  );
};
export default DeliveryGeneralInfo;
